import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/authService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import bg_img from "../assets/bg.png";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await authService.login(username, password);
      localStorage.setItem("token", JSON.stringify(response.data.data));
      localStorage.setItem(
        "apiKey",
        JSON.stringify(response.data?.data?.apiKey)
      );
      toast.success("লগইন সফল হয়েছে!", { position: "top-right" });
      navigate("/admin");
    } catch (err) {
      toast.error("ভুল ইউজারনেম বা পাসওয়ার্ড", { position: "top-right" });
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${bg_img})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        //   backdropFilter: "blur(8px)", // Blur effect for background image
        padding: "16px",
        fontFamily: "'Inter', sans-serif",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          // background: "rgba(17, 24, 39, 0.5)", // Semi-transparent overlay for contrast
          zIndex: 1,
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",
          //  background:
          //     "radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%)", // Blur light effect
          animation: "float 15s infinite ease-in-out",
          zIndex: 2,
        }}
      ></div>
      <ToastContainer style={{ zIndex: 99999 }} />
      <div
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          borderRadius: "16px",
          padding: "32px",
          maxWidth: "400px",
          width: "100%",
          boxShadow:
            "0 15px 50px rgba(0, 0, 0, 0.3), 0 0 20px rgba(16, 185, 129, 0.2)", // 3D shadow with light glow
          textAlign: "center",
          transform: "perspective(1000px) translateZ(20px)", // 3D effect
          transition: "transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out",
          position: "relative",
          zIndex: 3,
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform =
            "perspective(1000px) translateZ(40px)";
          e.currentTarget.style.boxShadow =
            "0 20px 60px rgba(0, 0, 0, 0.4), 0 0 30px rgba(16, 185, 129, 0.3)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform =
            "perspective(1000px) translateZ(20px)";
          e.currentTarget.style.boxShadow =
            "0 15px 50px rgba(0, 0, 0, 0.3), 0 0 20px rgba(16, 185, 129, 0.2)";
        }}
      >
        <h1
          style={{
            fontSize: "1.875rem",
            fontWeight: 700,
            color: "#1f2937",
            marginBottom: "24px",
          }}
        >
          লগইন
        </h1>
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: "24px" }}>
            <label
              htmlFor="username"
              style={{
                display: "block",
                fontSize: "1rem",
                fontWeight: 500,
                color: "#4b5563",
                marginBottom: "8px",
                textAlign: "left",
              }}
            >
              ইউজারনেম
            </label>
            <input
              type="text"
              id="username"
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "1rem",
                color: "#1f2937",
                backgroundColor: "#f9fafb",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              placeholder="ইউজারনেম লিখুন"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onFocus={(e) => {
                e.target.style.borderColor = "#10b981";
                e.target.style.boxShadow = "0 0 0 3px rgba(16, 185, 129, 0.3)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
              required
            />
          </div>
          <div style={{ marginBottom: "24px" }}>
            <label
              htmlFor="password"
              style={{
                display: "block",
                fontSize: "1rem",
                fontWeight: 500,
                color: "#4b5563",
                marginBottom: "8px",
                textAlign: "left",
              }}
            >
              পাসওয়ার্ড
            </label>
            <input
              type="password"
              id="password"
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "1rem",
                color: "#1f2937",
                backgroundColor: "#f9fafb",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              placeholder="পাসওয়ার্ড লিখুন"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={(e) => {
                e.target.style.borderColor = "#10b981";
                e.target.style.boxShadow = "0 0 0 3px rgba(16, 185, 129, 0.3)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
              required
            />
          </div>
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              background: "linear-gradient(90deg, #10b981, #059669)",
              border: "none",
              borderRadius: "9999px",
              color: "#ffffff",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: "pointer",
              transition: "background 0.2s ease, transform 0.2s ease",
              boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
            }}
            onMouseOver={(e) => {
              e.target.style.background =
                "linear-gradient(90deg, #059669, #047857)";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseOut={(e) => {
              e.target.style.background =
                "linear-gradient(90deg, #10b981, #059669)";
              e.target.style.transform = "translateY(0)";
            }}
            onFocus={(e) =>
              (e.target.style.boxShadow = "0 0 0 3px rgba(16, 185, 129, 0.3)")
            }
            onBlur={(e) =>
              (e.target.style.boxShadow = "0 4px 15px rgba(16, 185, 129, 0.3)")
            }
          >
            লগইন
          </button>
          <div
            style={{
              marginTop: "20px",
              textAlign: "center",
              fontSize: "0.875rem",
              color: "#4b5563",
            }}
          >
            <span>অ্যাকাউন্ট নেই? </span>
            <button
              style={{
                color: "#10b981",
                background: "none",
                border: "none",
                fontWeight: 600,
                cursor: "pointer",
                transition: "color 0.2s ease",
              }}
              onClick={() => navigate("/signup")}
              onMouseOver={(e) => (e.target.style.color = "#059669")}
              onMouseOut={(e) => (e.target.style.color = "#10b981")}
            >
              সাইন আপ
            </button>
          </div>
        </form>
      </div>
      <style>
        {`
          @keyframes float {
            0% { transform: translate(0, 0); opacity: 0.8; }
            50% { transform: translate(10%, 10%); opacity: 0.5; }
            100% { transform: translate(0, 0); opacity: 0.8; }
          }
        `}
      </style>
    </div>
  );
};

export default LoginPage;
